import { JudicialRecordView } from '@/components/templates/JudicialRecordView/JudicialRecordView'

import { useJudicialRecordPage } from './useJudicialRecordPage'

export const JudicialRecordPage = () => {
  const props = useJudicialRecordPage()
  return <JudicialRecordView {...props} />
}
